import { keyframes, styled } from "goober";
import { ClickButton } from "./ClickButton";
import { Icon } from "./Icon";

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Button = styled(ClickButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 8px 6px 6px;
  height: 24px;
  background: var(--surface-primary);
  border-left: 0.5px solid var(--border-alpha);

  &:hover {
    background: var(--surface-secondary);
  }
  &:disabled {
    opacity: 1;
  }
  span {
    opacity: 0.5;
  }
  &.running span {
    animation: ${spin} 1.5s linear infinite;
  }
`;

export function TestConnectionButton({
  running,
  onTest,
}: {
  running: boolean;
  onTest: () => void;
}) {
  return (
    <Button
      data-no-pill
      className={running ? "running" : undefined}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={onTest}
      disabled={running}
      title="Test connection"
    >
      <Icon name="refresh-cw" size={12} />
    </Button>
  );
}
